import {
	FETCH_ORDER_HISTORY,
	FETCH_SINGLE_ORDER,
	SET_ORDER_ID,
} from "./actionTypes";

const initialState = {
	orderHistory: [],
	singleOrder: [],
	order_id: "",
};

export default function (state = initialState, action) {
	switch (action.type) {
		case FETCH_ORDER_HISTORY:
			return {
				...state,
				orderHistory: action.payload,
			};
		case FETCH_SINGLE_ORDER:
			return {
				...state,
				singleOrder: action.payload,
			};
		case SET_ORDER_ID:
			return {
				...state,
				order_id: action.payload,
			};
		default:
			return state;
	}
}
